import React from 'react';
import { Result, Button } from 'antd';
import { FrownOutlined } from '@ant-design/icons';

interface ErrorStateProps {
  error: string;
  onRetry?: () => void;
}

const ErrorState: React.FC<ErrorStateProps> = ({ error, onRetry }) => {
  return (
    <div style={{ 
      padding: '40px 20px',
      animation: 'fadeIn 0.5s ease-out'
    }}>
      <Result
        icon={<FrownOutlined style={{ color: '#ff4d4f' }} />}
        status="error"
        title="Something went wrong"
        subTitle={error}
        extra={
          onRetry && (
            <Button 
              type="primary" 
              onClick={onRetry}
              style={{
                animation: 'fadeInUp 0.5s ease-out 0.2s',
                transition: 'all 0.3s ease'
              }}
            >
              Try Again
            </Button>
          )
        }
      />
      <style>
        {`
          @keyframes fadeIn {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(40px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .ant-result {
            padding: 24px;
            background: #fff;
            border-radius: 8px;
            box-shadow: 0 2px 8px rgba(0,0,0,0.1);
          }

          .ant-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0,0,0,0.15);
          }
        `}
      </style>
    </div>
  );
};

export default ErrorState;
